import React, { Component, useEffect, useState } from 'react';
import CountUp from 'react-countup';
import { connect } from 'react-redux';
import axios from 'axios';
import { Redirect } from 'react-router-dom';
import { useHistory } from "react-router-dom";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { API_BASE_URL } from '../../../config.js'
import DataTable, { defaultThemes } from 'react-data-table-component';
import Select from 'react-select';
// import { Button } from 'react-bootstrap';
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
// import 'bootstrap/dist/css/bootstrap.min.css';

// import DataTable from 'datatables.net-react';
// import DT from 'datatables.net-dt';

// DataTable.use(DT);
import {
statisticsAction,
statisticsCloseAction
} from '../../../actions/settingsAction';
import { Link } from 'react-router-dom/cjs/react-router-dom.min.js';
import { event } from 'jquery';
const Overtime = (props) => {
const sparkline1 = React.createRef();
const sparkline2 = React.createRef();
const sparkline3 = React.createRef();
const sparkline4 = React.createRef();

const [editData, setEditData] = useState(); // store data to edit
const [showEditModal, setShowEditModal] = useState(false); // toggle edit form/modal

const handleStatistics = (e) => {
statisticsAction(e)
}
const closeStatistics = (e) => {
statisticsCloseAction(e)
}

const { fixNavbar, statisticsOpen, statisticsClose } = props;
const emptyUser={
name: "",
education_level_id: "",


}

 
const [user, setUser] = useState({
document_type: "",
document_type_id:"",

})

const handelInput = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    console.log(name, value)
    setUser({ ...user, [name]: value });
}



const [url_name, setUrlname] = useState('');
const [url_id, setUrlid] = useState('');
const [url_link, setUrllink] = useState('');
const [parent, setParent] = useState('');
const history = useHistory();
const [data, setData] = useState([]);
const [datacount, setDataCount] = useState([]);
const [dataval, setdataval] = useState([]);
const [currentPageId, setCurrentPageId] = useState(1);
const [loading, setLoading] = useState(false);
const [error, setError] = useState(null);
const [table, setTable] = useState([]);
const [setcmp, setcompany] = useState([]);
const [setdept, setDept] = useState([]);

const [formData, setFormData] = useState({
    name: '',

company_id:'',


});




const handleEdit = async (overtime_id) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/edit_overtime/${overtime_id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`
      }
    });
   setEditData(response.data);
   setOriginalOvertimeHour(response.data.overtime_hour);
console.log("Set editData:", response.data.data);// assuming your API returns { data: { ... } }
    setShowEditModal(true);
  } catch (error) {
    console.error("Error fetching overtime entry:", error);
    toast.error("Failed to fetch overtime entry.", {
      position: "bottom-right",
      autoClose: 3000,
      theme: "colored",
    });
  }
};

const [originalOvertimeHour, setOriginalOvertimeHour] = useState();



  

	const submitEdit = (e) => {
  const newHour = (editData.overtime_hour);
  const originalHour = (originalOvertimeHour);
 
  if (newHour > originalHour) {
    toast.error("You are not allowed to increase the Overtime Hour.", {
      position: "bottom-right",
      autoClose: 5000,
      theme: "colored",
    });
    return;
  }

  axios.post(API_BASE_URL + '/overtime_update', {
    overtime_id: editData.overtime_id,
    overtime_hour: editData.overtime_hour,
            status: editData.status,

        overtime_date: editData.overtime_date,

    reason: editData.reason
  }, {
    headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
  }).then(response => {
    const status = response.data.status;

    if (status === 'success') {
      toast.success(response.data.message, {
        position: "bottom-right",
        autoClose: 5000,
        theme: "colored",
      });
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    } else {
      toast.error(response.data.message, {
        position: "bottom-right",
        autoClose: 5000,
        theme: "colored",
      });
    }
  }).catch(error => {
    toast.error(error.response?.data?.message || "Update failed", {
      position: "bottom-right",
      autoClose: 5000,
      theme: "colored",
    });
  });
};




const handleChange = (e) => {

const { name, value } = e.target;
setFormData({
...formData,
[name]: value,
});
};
// const [anand, setAnand]= useState([]);
const [searchTerm, setSearchTerm] = useState("");
const [currentPage, setCurrentPage] = useState(1);
const [itemsPerPage, setItemsPerPage] = useState(10);
// const itemsPerPage = 10;
const indexOfLastItem = currentPage * itemsPerPage;
const indexOfFirstItem = indexOfLastItem - itemsPerPage;
let filteredItems = table.filter((item) =>



`${item.name.toLowerCase()}${item.emp_id.toLowerCase()}`.includes(searchTerm.toLowerCase())

);
const filteredData = filteredItems.slice(indexOfFirstItem, indexOfLastItem);
const startIndex = (currentPage - 1) * itemsPerPage;

useEffect(() => {
setCurrentPage(1);
}, [searchTerm]);

const paginate = (pageNumber) => setCurrentPage(pageNumber);

const handleSearch = (event) => {
setSearchTerm(event.target.value);
};


const clearInput = () => {
setSearchTerm("");
};


const handleRowsPerPageChange = (e) => {
setItemsPerPage(Number(e.target.value));
setCurrentPage(1); // Reset to first page
};






    useEffect(() => {
  axios
    .get(API_BASE_URL + '/overtime_list', {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`,
      },
    })
    .then((response) => {
      console.log(response.data.data);
      setTable(response.data.data.overtime_list); // ✅ CORRECT
      setData(response.data.data.overtime_list);  // ✅ if used elsewhere
      setLoading(false);
    })
    .catch((error) => {
      setError(error.message);
      setLoading(false);
    });
}, []);





var elements = [];
for (var i = 1; i <= datacount.total_page; i++) {
elements.push(i);
}

//   for(var i=1;i<=datacount.total_page;i++){
// 	elements.push(<li className="page-item"><a className="page-link" href="" onClick={() => handlePagination(i)}>
// 	  {i}
//   </a></li>);
// }

//console.log(elements)

//   const [currentPage,setCurrentPage]= useState(1);
const recordsPerPage = 10;

const lastIndex = currentPage * recordsPerPage;
const firstIndex = lastIndex - recordsPerPage;
const records = data.slice(firstIndex, lastIndex);
const npage = Math.ceil(data.length / recordsPerPage);
const numbers = [...Array(npage + 1).keys()].slice(1);




// const paginate= (page) => setCurrentPage(page);












const handleFetchOvertime = async () => {
  setLoading(true);
  try {
    const response = await axios.post(API_BASE_URL + '/fetch_overtime', {}, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`
      }
    });

    toast.success("Overtime data fetched successfully!", {
      position: "bottom-right",
      autoClose: 3000,
      theme: "colored",
    });

    // Optionally reload list from GET
    reloadOvertimeList();
  } catch (error) {
    toast.error("Failed to fetch overtime data.", {
      position: "bottom-right",
      autoClose: 3000,
      theme: "colored",
    });
    console.error("Fetch overtime error:", error);
  } finally {
    setLoading(false);
  }
};
const reloadOvertimeList = () => {
  axios
    .get(API_BASE_URL + '/overtime_list', {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`
      }
    })
    .then((response) => {
      setTable(response.data.data.overtime_list);
      setData(response.data.data.overtime_list);
    })
    .catch((error) => {
      console.error("Error reloading overtime list:", error);
    });
};
return (
<>


<div>
<div>
<div className={`section-body ${fixNavbar ? "marginTop" : ""} `}>
<div className="container-fluid">

<ToastContainer />
<h3 className="card-title" style={{ color: '#e96827' }}> Overtime </h3>
<form onSubmit="">
  <div className="mb-4 d-flex justify-content-between align-items-center">
  <h2 className="text-xl font-bold m-0">Overtime</h2>
  <div className="ms-auto">
    <button
  type="button"
  className="btn btn-sm"
  style={{ backgroundColor: '#e96827', color: '#fff', padding: '6px 12px', borderRadius: '4px', fontWeight: 'bold' }}
  onClick={handleFetchOvertime}
>
  <span className="me-2">+</span> Fetch Overtime Data
</button>
  </div>
</div>
</form>

</div>
</div>


<div className="section-body">
<div className="container-fluid">
<div className="tab-content">
<div className="tab-pane fade show active" id="Employee-list" role="tabpanel">
<div className="card">
<div className="card-header">
<h3 className="card-title" style={{ color: '#e96827' }}>Overtime List</h3>
<div className="card-options" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '20px' }}>

<div className="input-group">

<select style={{
padding: '8px',
marginRight: '20px',
borderRadius: '4px',
border: '1px solid #ccc',
backgroundColor: '#BCD1DB', display: 'flex', justifyContent: 'left'
}}
id="rowsPerPage"
value={itemsPerPage}
onChange={handleRowsPerPageChange}
>
<option value={10}>10</option>
<option value={25}>25</option>
<option value={50}>50</option>
<option value={100}>100</option>
</select>

<div style={{ position: "relative", width: "300px" }}>

<input
type="text"
className="form-control form-control-sm"
placeholder="Search"
value={searchTerm}
onChange={handleSearch} 
style={{
width: "100%",
padding: "10px",
paddingRight: "30px", // Extra space for the clear icon
boxSizing: "border-box",
}}
// style={{ padding: '8px', width: '200px', borderRadius: '4px', border: '1px solid #ccc' }}
/>

{searchTerm.length>0 && ( 
<span
onClick={clearInput}
style={{
position: "absolute",
top: "50%",
right:"10px",
transform: "translateY(-50%)",
cursor: "pointer",
color: "#aaa",
fontSize: "18px",
// marginLeft: '260px !important',

}}
>
✖
</span>
)}
</div>



</div>

</div>
</div>












<div className="card-body">
<div className="table-responsive">
<table className="table table-hover table-striped table-vcenter text-nowrap mb-0">
<thead>
<tr>
<th>Action</th>
<th>Employee ID</th> 
          <th>Employee Name</th>
         
          <th>Employee Dept</th>
          <th>Employee Shift</th>
          <th>Overtime Date</th>
          <th>Before Shift</th>
          <th>After Shift</th>
      
          <th>Total Work Hours </th>
          <th>Total Overtime</th>
          <th>Request</th>
          <th>Update On</th>
         <th>Reason</th>
          <th>Incharge</th>
          <th>HOD Status</th>
          <th>HR Status</th>
          
</tr>
</thead>

  <tbody>
    {filteredData.map((row, index) => (
      <tr key={index}>
     <td>
  {row.is_applied!= 1 && (
    <button
      className="btn btn-sm btn-primary"
      onClick={() => handleEdit(row.overtime_id)}
    >
      <i className="fa fa-edit" />
    </button>
  )}
</td>
        <td>{row.emp_id}</td>
        <td>{row.name}</td>
        <td>{row.department_name}</td>
        <td>{row.shift_name}</td>
        <td>{row.overtime_date}</td>
        <td>{row.before_shift}</td>
        <td>{row.after_shift}</td>
        <td>{row.total_works}</td>
        <td>{row.total_overtime}</td>
        <td>{row.status}</td>
        <td>{row.update_on}</td>
        <td>{row.reason}</td>
       <td>
        <span>{ReactHtmlParser(row.incharge)}</span>
        </td>
       <td>
        <span>{ReactHtmlParser(row.hod)}</span>
        </td>
         <td>
        <span>{ReactHtmlParser(row.hr)}</span>
        </td>
      </tr>
    ))}
  </tbody>
</table>
</div>


	{showEditModal && (
  <div className="modal fade show d-block" tabIndex="-1" role="dialog">
<div
  className="modal-dialog modal-dialog-centered"
  role="document"
  style={{ maxWidth: '600px', width: '90%' }}
>    <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Overtime Request</h5>
          <button type="button" className="close" onClick={() => setShowEditModal(false)}>
            <span aria-hidden="true">×</span>
          </button>
        </div>
					<input name="overtime_id" id="overtime_id" value={editData?.overtime_id} type="hidden" />

        <div className="modal-body">
          <div className="row">
            {/* LEFT COLUMN - Labels and Static Values */}
            <div className="col-md-6">
              <div className="mb-3">
                <label>Overtime Date</label>
                                <div className="border p-2 bg-light">{editData?.overtime_date}</div>

              </div>

              {/* <div className="mb-3">
                <label><strong>Applied On</strong></label>
                <div className="border p-2 bg-light">{editData?.applied_on}</div>
              </div> */}

              {/* <div className="mb-3">
                <label><strong>Shift Time</strong></label>
                <div className="border p-2 bg-light">
                  {editData?.shift_name} <br />
                  <small className="text-muted">{editData?.shift_start} - {editData?.shift_end}</small>
                </div>
              </div> */}

              {/* <div className="mb-3">
                <label><strong>Punch In & Out</strong></label>
                <div className="border p-2 bg-light">{editData?.punch_in} - {editData?.punch_out}</div>
              </div> */}

              <div className="mb-3">
                <label>Total Hours</label>
                <div className="border p-2 bg-light">{editData?.total_work_hours}</div>
              </div>
            </div>

            {/* RIGHT COLUMN - Editable Fields */}
            
            <div className="col-md-6">
                              <label>Status</label>

              <select
  name="status"
  className="form-control"
  value={editData?.status || ''}
  onChange={(e) =>
    setEditData({ ...editData, status: parseInt(e.target.value) })
  }
>
 
  <option value={2}>Request</option>
  <option value={3}>Reject</option>
</select>

              <div className="mb-3">
                <label>Overtime Hour</label>
                <input
                  type="text"
                  name="overtime_hour"
                  className="form-control"
                  value={editData?.overtime_hour || ''}
                  onChange={(e) => setEditData({ ...editData, overtime_hour: e.target.value })}
                />
              </div>

              <div className="mb-3">
               <label>Reason <span style={{color:"red"}}>*</span></label>

                <textarea
                  className="form-control"
                  rows={4}
                  name="reason"
                  value={editData?.reason || ''}
                  onChange={(e) => setEditData({ ...editData, reason: e.target.value })}
                  placeholder="Reason"
                ></textarea>
              </div>
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={() => setShowEditModal(false)}>
            Close
          </button>
          <button
            className="btn"
            onClick={submitEdit}
            style={{
              backgroundColor: '#e96827',
              color: '#fff',
              padding: '8px 16px',
              borderRadius: '4px',
              fontWeight: 'bold',
              border: 'none',
            }}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  </div>
)}



<nav aria-label="Page navigation">
<ul className="pagination mb-0 justify-content-end">
<li className="page-item"><button className="page-link"
key={'f'}
// style={{
//   backgroundColor: currentPage ===  1 && "lightgreen",
// }}
onClick={() => paginate(1)}
>
First
</button></li>

{Array.from(
{ length: Math.ceil(filteredItems.length / itemsPerPage) },
(_, index) => (
<li className="page-item">
<button className="page-link"
key={index + 1}
// style={{
//   backgroundColor: currentPage === index + 1 && "lightgreen",
// }}
onClick={() => paginate(index + 1)}
>
{index + 1}
</button></li>
)
)}

<li className="page-item">
<button className="page-link"
key={'l'}
// style={{
//   backgroundColor: currentPage ===  Math.ceil(filteredItems.length / itemsPerPage) && "lightgreen",
// }}
onClick={() => paginate(Math.ceil(filteredItems.length / itemsPerPage))}
>
Last
</button></li>






</ul>
</nav>









</div>
</div>
</div>


</div>
</div>
</div>

</div>
</div>





</>
);

}



const mapStateToProps = (state) => ({
fixNavbar: state.settings.isFixNavbar,
statisticsOpen: state.settings.isStatistics,
statisticsClose: state.settings.isStatisticsClose,
})

const mapDispatchToProps = (dispatch) => ({
statisticsAction: (e) => dispatch(statisticsAction(e)),
statisticsCloseAction: (e) => dispatch(statisticsCloseAction(e))
})
export default connect(mapStateToProps, mapDispatchToProps)(Overtime);  